// PageVariablesApolices.js

export const pageVariables = {
    headers: [
        'Nº APÓLICE', 'EMPRESA', 'SEGURADORA', 'ENCAMPAÇÃO', 'PERM. VENDA', 'CANCELADA', 'MÊS CÁLC. IPCA'
    ],
    headerInfo: {
        title: "Apólices",
        description: "Esta seção fornece informações detalhadas sobre as apólices, incluindo dados como segurado, tipo de cobertura, valor da apólice e vigência. Acompanhe e gerencie as apólices emitidas para garantir que estejam adequadas às necessidades dos segurados e cumpram as exigências contratuais."
    },     
    inputs: [
        {
            name: "numero",
            type: "text",
            label: "Número da Apólice"
        }
    ],
    page: process.env.VUE_APP_API_URL+"apolices",
};
